<template>
  <div class="InteractiveThumbnail"
    :is="tagType"
    v-bind="attributes">

    <thumbnail class="InteractiveThumbnail-image"
      v-if="image"
      :image="image"
      :button="{
        icon: 'interactive',
        label
      }" />

  </div>
</template>

<script>
export default {
  name: 'InteractiveThumbnail',

  props: {
    route: {
      type: Object
    },
    link: {
      type: String
    },
    image: {
      type: Object,
      required: true
    },
    label: {
      type: String,
      default () {
        return 'Visit website'
      }
    }
  },

  computed: {
    /**
     * Return appropriate top-level tag
     * @return {String}
     */
    tagType () {
      // Handle standard link
      if (this.link) return 'a'

      // Handle internal route
      if (this.route) return 'router-link'

      return 'div'
    },

    /**
     * Return appropriate attributes depending on top-level tag
     * @return {Object}
     */
    attributes () {
      // Handle standard link
      if (this.link) return { href: this.link }

      // Handle internal route
      if (this.route) return { to: this.route }
    }
  }
}
</script>



// WEBPACK FOOTER //
// InteractiveThumbnail.vue?38fbecd0